require('./bootstrap');

import store from './store';

require('./components/register-form');
require('./components/submit-form');
require('./components/question-form');

window.WebApp = new Vue({
    el: '#app',
    delimiters: ['${', '}'],

    data() {
        return {
            state: store.state,
            client: store.client,
            chapters: store.chapters,
            answers: store.answers,
            currentChapter: 0,
            currentQuestion: 0,
            currentAnswer: null,
            currentRemark: null,
            showChapterStart: true,
            showChapterEnd: false,
            showThankYou: false
        };
    },

    computed: {
        charactersLeft() {
            let limit = 250;

            if (this.currentRemark) {
                let char = this.currentRemark.length;

                if (char >= limit) {
                    this.currentRemark = this.currentRemark.substring(0,249);
                }

                return (limit - char);
            }

            return limit;
          }
    },

    mounted() {
        this.chapters = JSON.parse(this.$el.dataset.chapters);
    },

    methods: {
        goToRegistration() {
            store.setSection('welcome');
            this.scrollToTop();
        },

        startSurvey() {
            store.setSection('poi');
            this.scrollToTop();
        },

        goToSection() {
            store.setSection('chapter');
            this.showChapterStart = false;
            this.scrollToTop();
        },

        goToFirstChapter() {
            store.setSection('chapter');
            this.showChapterStart = true;
            this.scrollToTop();
        },

        setQuestionHeaderClass(chapterID) {
            if (chapterID == this.currentChapter) {
                return 'active' 
            }
        },

        selectAnswer(choice, key, event) {
            this.currentAnswer = choice;
        },

        previousQuestion() {
            if (this.showChapterStart) {
                this.previousChapter();
                return;
            }
            if (this.currentQuestion === 0) {
                this.showChapterStart = true;
                return;
            }

            this.showChapterEnd = false;
            this.currentQuestion -= 1;
        },

        nextQuestion() {
            this.saveAnswer();
            this.resetQuestion();

            if (this.currentQuestion == this.chapters[this.currentChapter].questions.length - 1) {
                this.goToChapterEnd();
                return;
            }

            this.currentQuestion = this.currentQuestion + 1;
            
        },

        resetQuestion() {
            this.currentAnswer = null;
            this.currentRemark = null;
        },

        saveAnswer() {
            if (!this.answers[this.currentChapter]) {
                this.answers.push({});
            }

            this.answers[this.currentChapter][this.currentQuestion] = {
                'answer': this.currentAnswer,
                'remark': this.currentRemark
             }
        },

        goToChapterEnd() {
            this.showChapterEnd = true;
        },

        previousChapter() {
            if (this.currentChapter === 0) {
                this.goToRegistration();
                return;
            }
            this.currentChapter -= 1;
            this.currentQuestion = this.chapters[this.currentChapter].questions.length;
            this.showChapterStart = false;
            this.showChapterEnd = true;
        },

        nextChapter() {
            if (this.currentChapter == this.chapters.length - 1) {
                this.goToChapterEnd();
                return;
            }
            this.showChapterStart = true;
            this.showChapterEnd = false;
            this.currentQuestion = 0 ;
            this.currentChapter = this.currentChapter + 1;
        },

        toEndScreen() {
            store.setSection('end');
        },

        // goBack() {
        //     store.setSection(store.state.previousSection);
        //     this.scrollToTop();
        // },

        scrollToTop() {
            Vue.nextTick(() => {
                window.scrollTo(0, 0);
            });
        },

        reload() {
            window.location.reload();
        },

        
    }


});